// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: VNg5TpG8cz6

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SourceCategoryButton from "../../SourceCategoryButton"; // plasmic-import: UJeCFCdk-Ve/component
import Dropdown from "../../Dropdown"; // plasmic-import: XI-q-Su25C/component
import SmallOverlayMenu from "../../SmallOverlayMenu"; // plasmic-import: 6okmavSCY4v/component
import SectionSettingsSourcePanel from "../../SectionSettingsSourcePanel"; // plasmic-import: 6absOovmls/component
import SearchBar from "../../SearchBar"; // plasmic-import: FRemyPrB4r/component
import Button from "../../Button"; // plasmic-import: JUDb72ncw4_/component
import InterestTilePanel from "../../InterestTilePanel"; // plasmic-import: cuZ6tw1Eyboy/component
import Arrows from "../../Arrows"; // plasmic-import: W9XdlIeiuX/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSectionSettings.module.css"; // plasmic-import: VNg5TpG8cz6/css

import IconarrowIosLeftIcon from "./icons/PlasmicIcon__IconarrowIosLeft"; // plasmic-import: XC5sZv_QpIv/icon
import EllipseIcon from "./icons/PlasmicIcon__Ellipse"; // plasmic-import: 7yEdT9gylu9/icon
import ArrowsIcon from "./icons/PlasmicIcon__Arrows"; // plasmic-import: htjxqImWe45/icon
import MenuIcon4Icon from "./icons/PlasmicIcon__MenuIcon4"; // plasmic-import: vBt4GMoI8Z/icon
import ClosesvgIcon from "./icons/PlasmicIcon__Closesvg"; // plasmic-import: ze_MFlDSdi/icon
import IconsDeleteIcon from "./icons/PlasmicIcon__IconsDelete"; // plasmic-import: svOIRRDbImq/icon
import LineIcon from "./icons/PlasmicIcon__Line"; // plasmic-import: 3u8WV45N_Pz/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: -JcA6DjnTkO/icon
import Icon6Icon from "./icons/PlasmicIcon__Icon6"; // plasmic-import: DIlIifijFvS/icon
import _27IcontwitterIcon from "./icons/PlasmicIcon___27Icontwitter"; // plasmic-import: OLUGpSl8i4I/icon

createPlasmicElementProxy;

export type PlasmicSectionSettings__VariantMembers = {
  footer: "twitterConnect" | "hidden";
  connectingWith: "twitter" | "spotify";
  categoryTypeOverview: "pro" | "complete" | "free";
  categoryOverviewForType: "youtube" | "twitter" | "spotify";
  baseVariant:
    | "_default"
    | "searchResults"
    | "expanded"
    | "playlistInput"
    | "searchTermInput"
    | "noSources"
    | "urlSearch";
};
export type PlasmicSectionSettings__VariantsArgs = {
  footer?: SingleChoiceArg<"twitterConnect" | "hidden">;
  connectingWith?: SingleChoiceArg<"twitter" | "spotify">;
  categoryTypeOverview?: SingleChoiceArg<"pro" | "complete" | "free">;
  categoryOverviewForType?: SingleChoiceArg<"youtube" | "twitter" | "spotify">;
  baseVariant?: SingleChoiceArg<
    | "_default"
    | "searchResults"
    | "expanded"
    | "playlistInput"
    | "searchTermInput"
    | "noSources"
    | "urlSearch"
  >;
};
type VariantPropType = keyof PlasmicSectionSettings__VariantsArgs;
export const PlasmicSectionSettings__VariantProps = new Array<VariantPropType>(
  "footer",
  "connectingWith",
  "categoryTypeOverview",
  "categoryOverviewForType",
  "baseVariant"
);

export type PlasmicSectionSettings__ArgsType = {
  suggestionStack?: React.ReactNode;
  vis?: string;
};
type ArgPropType = keyof PlasmicSectionSettings__ArgsType;
export const PlasmicSectionSettings__ArgProps = new Array<ArgPropType>(
  "suggestionStack",
  "vis"
);

export type PlasmicSectionSettings__OverridesType = {
  root?: p.Flex<"div">;
  sectionSettings?: p.Flex<"div">;
  sourceCategorySelectionBackButton?: p.Flex<"button">;
  leftArrow?: p.Flex<"svg">;
  sourceCategoryButtonStack?: p.Flex<"div">;
  websites?: p.Flex<typeof SourceCategoryButton>;
  youtube?: p.Flex<typeof SourceCategoryButton>;
  youtubeChannels?: p.Flex<typeof SourceCategoryButton>;
  youtubePlaylists?: p.Flex<typeof SourceCategoryButton>;
  twitter?: p.Flex<typeof SourceCategoryButton>;
  twitterTimelines?: p.Flex<typeof SourceCategoryButton>;
  twitterBookmarks?: p.Flex<typeof SourceCategoryButton>;
  twitterHomeFeed?: p.Flex<typeof SourceCategoryButton>;
  twitterLikes?: p.Flex<typeof SourceCategoryButton>;
  twitterMentions?: p.Flex<typeof SourceCategoryButton>;
  twitterLists?: p.Flex<typeof SourceCategoryButton>;
  twitterSearches?: p.Flex<typeof SourceCategoryButton>;
  spotifyMusicians?: p.Flex<typeof SourceCategoryButton>;
  spotifyPodcasts?: p.Flex<typeof SourceCategoryButton>;
  spotifyPlaylists?: p.Flex<typeof SourceCategoryButton>;
  podcasts?: p.Flex<typeof SourceCategoryButton>;
  savedForLater?: p.Flex<typeof SourceCategoryButton>;
  spotify?: p.Flex<typeof SourceCategoryButton>;
  sourceCategoryOptions?: p.Flex<"div">;
  sourceCategorySelection?: p.Flex<"div">;
  plus?: p.Flex<"div">;
  rectangle3?: p.Flex<"div">;
  rectangle4?: p.Flex<"div">;
  currentSourceCategory?: p.Flex<typeof SourceCategoryButton>;
  sortingModeBox?: p.Flex<"div">;
  dropdown?: p.Flex<"div">;
  sortingMode?: p.Flex<"div">;
  sortingMode2?: p.Flex<"div">;
  sortingModeDropdown?: p.Flex<typeof Dropdown>;
  optionsMenu?: p.Flex<"div">;
  overlayMenuBtn?: p.Flex<typeof SmallOverlayMenu>;
  menuButton?: p.Flex<"button">;
  localHeaderSubmenu?: p.Flex<typeof p.PlasmicImg>;
  closeButton?: p.Flex<"button">;
  close?: p.Flex<"svg">;
  deleteSectionButton?: p.Flex<"button">;
  group232?: p.Flex<"div">;
  group267?: p.Flex<"div">;
  darkMode?: p.Flex<"div">;
  darkMode2?: p.Flex<"div">;
  group266?: p.Flex<"div">;
  eggshellMode?: p.Flex<"div">;
  sectionSettingsContent?: p.Flex<"div">;
  contentFrame?: p.Flex<"div">;
  sectionSettingsSourcePanel?: p.Flex<typeof SectionSettingsSourcePanel>;
  sourceList?: p.Flex<"div">;
  searchBar?: p.Flex<typeof SearchBar>;
  resultsPanel?: p.Flex<"div">;
  interestTilePanel?: p.Flex<typeof InterestTilePanel>;
  suggestionContainer?: p.Flex<"div">;
  arrows?: p.Flex<typeof Arrows>;
  suggestionStack?: p.Flex<"div">;
  expandButton?: p.Flex<"div">;
  footerButton?: p.Flex<"div">;
  redirectingDelete?: p.Flex<"div">;
};

export interface DefaultSectionSettingsProps {
  suggestionStack?: React.ReactNode;
  vis?: string;
  footer?: SingleChoiceArg<"twitterConnect" | "hidden">;
  connectingWith?: SingleChoiceArg<"twitter" | "spotify">;
  categoryTypeOverview?: SingleChoiceArg<"pro" | "complete" | "free">;
  categoryOverviewForType?: SingleChoiceArg<"youtube" | "twitter" | "spotify">;
  baseVariant?: SingleChoiceArg<
    | "_default"
    | "searchResults"
    | "expanded"
    | "playlistInput"
    | "searchTermInput"
    | "noSources"
    | "urlSearch"
  >;
  className?: string;
}

const $$ = {};

function PlasmicSectionSettings__RenderFunc(props: {
  variants: PlasmicSectionSettings__VariantsArgs;
  args: PlasmicSectionSettings__ArgsType;
  overrides: PlasmicSectionSettings__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "footer",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.footer
      },
      {
        path: "connectingWith",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.connectingWith
      },
      {
        path: "categoryTypeOverview",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.categoryTypeOverview
      },
      {
        path: "categoryOverviewForType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.categoryOverviewForType
      },
      {
        path: "baseVariant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.baseVariant
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootbaseVariant__default]: hasVariant(
            $state,
            "baseVariant",
            "_default"
          ),
          [sty.rootbaseVariant_searchTermInput]: hasVariant(
            $state,
            "baseVariant",
            "searchTermInput"
          ),
          [sty.rootcategoryOverviewForType_spotify]: hasVariant(
            $state,
            "categoryOverviewForType",
            "spotify"
          ),
          [sty.rootcategoryOverviewForType_twitter]: hasVariant(
            $state,
            "categoryOverviewForType",
            "twitter"
          ),
          [sty.rootcategoryOverviewForType_youtube]: hasVariant(
            $state,
            "categoryOverviewForType",
            "youtube"
          ),
          [sty.rootcategoryTypeOverview_complete]: hasVariant(
            $state,
            "categoryTypeOverview",
            "complete"
          ),
          [sty.rootcategoryTypeOverview_free]: hasVariant(
            $state,
            "categoryTypeOverview",
            "free"
          ),
          [sty.rootcategoryTypeOverview_pro]: hasVariant(
            $state,
            "categoryTypeOverview",
            "pro"
          ),
          [sty.rootconnectingWith_spotify]: hasVariant(
            $state,
            "connectingWith",
            "spotify"
          ),
          [sty.rootconnectingWith_twitter]: hasVariant(
            $state,
            "connectingWith",
            "twitter"
          )
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"sectionSettings"}
        data-plasmic-override={overrides.sectionSettings}
        hasGap={true}
        className={classNames(projectcss.all, sty.sectionSettings, {
          [sty.sectionSettingsbaseVariant__default]: hasVariant(
            $state,
            "baseVariant",
            "_default"
          ),
          [sty.sectionSettingsbaseVariant_expanded]: hasVariant(
            $state,
            "baseVariant",
            "expanded"
          ),
          [sty.sectionSettingsbaseVariant_noSources]: hasVariant(
            $state,
            "baseVariant",
            "noSources"
          ),
          [sty.sectionSettingsbaseVariant_playlistInput]: hasVariant(
            $state,
            "baseVariant",
            "playlistInput"
          ),
          [sty.sectionSettingsbaseVariant_searchResults]: hasVariant(
            $state,
            "baseVariant",
            "searchResults"
          ),
          [sty.sectionSettingsbaseVariant_searchTermInput]: hasVariant(
            $state,
            "baseVariant",
            "searchTermInput"
          ),
          [sty.sectionSettingsbaseVariant_urlSearch]: hasVariant(
            $state,
            "baseVariant",
            "urlSearch"
          ),
          [sty.sectionSettingscategoryOverviewForType_spotify]: hasVariant(
            $state,
            "categoryOverviewForType",
            "spotify"
          ),
          [sty.sectionSettingscategoryOverviewForType_twitter]: hasVariant(
            $state,
            "categoryOverviewForType",
            "twitter"
          ),
          [sty.sectionSettingscategoryOverviewForType_youtube]: hasVariant(
            $state,
            "categoryOverviewForType",
            "youtube"
          ),
          [sty.sectionSettingscategoryTypeOverview_complete]: hasVariant(
            $state,
            "categoryTypeOverview",
            "complete"
          ),
          [sty.sectionSettingscategoryTypeOverview_free]: hasVariant(
            $state,
            "categoryTypeOverview",
            "free"
          ),
          [sty.sectionSettingscategoryTypeOverview_pro]: hasVariant(
            $state,
            "categoryTypeOverview",
            "pro"
          ),
          [sty.sectionSettingsconnectingWith_spotify]: hasVariant(
            $state,
            "connectingWith",
            "spotify"
          ),
          [sty.sectionSettingsconnectingWith_twitter]: hasVariant(
            $state,
            "connectingWith",
            "twitter"
          ),
          [sty.sectionSettingsfooter_hidden]: hasVariant(
            $state,
            "footer",
            "hidden"
          ),
          [sty.sectionSettingsfooter_twitterConnect]: hasVariant(
            $state,
            "footer",
            "twitterConnect"
          )
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__wLyk, {
            [sty.freeBoxbaseVariant_noSources__wLykAeYH]: hasVariant(
              $state,
              "baseVariant",
              "noSources"
            ),
            [sty.freeBoxcategoryOverviewForType_spotify__wLykO7Fwt]: hasVariant(
              $state,
              "categoryOverviewForType",
              "spotify"
            ),
            [sty.freeBoxcategoryOverviewForType_twitter__wLykYtWIf]: hasVariant(
              $state,
              "categoryOverviewForType",
              "twitter"
            ),
            [sty.freeBoxcategoryOverviewForType_youtube__wLykKVGoG]: hasVariant(
              $state,
              "categoryOverviewForType",
              "youtube"
            ),
            [sty.freeBoxcategoryTypeOverview_complete__wLykWqYA]: hasVariant(
              $state,
              "categoryTypeOverview",
              "complete"
            ),
            [sty.freeBoxcategoryTypeOverview_free__wLykArOg]: hasVariant(
              $state,
              "categoryTypeOverview",
              "free"
            ),
            [sty.freeBoxcategoryTypeOverview_pro__wLykAtOnj]: hasVariant(
              $state,
              "categoryTypeOverview",
              "pro"
            ),
            [sty.freeBoxconnectingWith_spotify__wLykXHcTg]: hasVariant(
              $state,
              "connectingWith",
              "spotify"
            ),
            [sty.freeBoxconnectingWith_twitter__wLykS4RmW]: hasVariant(
              $state,
              "connectingWith",
              "twitter"
            )
          })}
        >
          <button
            data-plasmic-name={"sourceCategorySelectionBackButton"}
            data-plasmic-override={overrides.sourceCategorySelectionBackButton}
            className={classNames(
              projectcss.all,
              projectcss.button,
              sty.sourceCategorySelectionBackButton,
              {
                [sty.sourceCategorySelectionBackButtonbaseVariant_noSources]:
                  hasVariant($state, "baseVariant", "noSources"),
                [sty.sourceCategorySelectionBackButtoncategoryOverviewForType_spotify]:
                  hasVariant($state, "categoryOverviewForType", "spotify"),
                [sty.sourceCategorySelectionBackButtoncategoryOverviewForType_twitter]:
                  hasVariant($state, "categoryOverviewForType", "twitter"),
                [sty.sourceCategorySelectionBackButtoncategoryOverviewForType_youtube]:
                  hasVariant($state, "categoryOverviewForType", "youtube"),
                [sty.sourceCategorySelectionBackButtoncategoryTypeOverview_complete]:
                  hasVariant($state, "categoryTypeOverview", "complete"),
                [sty.sourceCategorySelectionBackButtoncategoryTypeOverview_free]:
                  hasVariant($state, "categoryTypeOverview", "free"),
                [sty.sourceCategorySelectionBackButtoncategoryTypeOverview_pro]:
                  hasVariant($state, "categoryTypeOverview", "pro"),
                [sty.sourceCategorySelectionBackButtonconnectingWith_spotify]:
                  hasVariant($state, "connectingWith", "spotify"),
                [sty.sourceCategorySelectionBackButtonconnectingWith_twitter]:
                  hasVariant($state, "connectingWith", "twitter")
              }
            )}
            ref={ref => {
              $refs["sourceCategorySelectionBackButton"] = ref;
            }}
          >
            <IconarrowIosLeftIcon
              data-plasmic-name={"leftArrow"}
              data-plasmic-override={overrides.leftArrow}
              className={classNames(projectcss.all, sty.leftArrow, {
                [sty.leftArrowcategoryOverviewForType_spotify]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "spotify"
                ),
                [sty.leftArrowcategoryOverviewForType_twitter]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "twitter"
                ),
                [sty.leftArrowcategoryOverviewForType_youtube]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "youtube"
                ),
                [sty.leftArrowcategoryTypeOverview_complete]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "complete"
                ),
                [sty.leftArrowcategoryTypeOverview_free]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "free"
                ),
                [sty.leftArrowcategoryTypeOverview_pro]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "pro"
                ),
                [sty.leftArrowconnectingWith_spotify]: hasVariant(
                  $state,
                  "connectingWith",
                  "spotify"
                ),
                [sty.leftArrowconnectingWith_twitter]: hasVariant(
                  $state,
                  "connectingWith",
                  "twitter"
                )
              })}
              role={"img"}
            />
          </button>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__xCeac,
              {
                [sty.textcategoryOverviewForType_spotify__xCeacO7Fwt]:
                  hasVariant($state, "categoryOverviewForType", "spotify"),
                [sty.textcategoryOverviewForType_twitter__xCeacYtWIf]:
                  hasVariant($state, "categoryOverviewForType", "twitter"),
                [sty.textcategoryOverviewForType_youtube__xCeackVGoG]:
                  hasVariant($state, "categoryOverviewForType", "youtube"),
                [sty.textcategoryTypeOverview_complete__xCeacWqYA]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "complete"
                ),
                [sty.textcategoryTypeOverview_free__xCeacArOg]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "free"
                ),
                [sty.textcategoryTypeOverview_pro__xCeacatOnj]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "pro"
                ),
                [sty.textconnectingWith_spotify__xCeacxHcTg]: hasVariant(
                  $state,
                  "connectingWith",
                  "spotify"
                ),
                [sty.textconnectingWith_twitter__xCeacs4RmW]: hasVariant(
                  $state,
                  "connectingWith",
                  "twitter"
                )
              }
            )}
          >
            {hasVariant($state, "categoryOverviewForType", "youtube")
              ? "Choose a Source Category:"
              : hasVariant($state, "connectingWith", "spotify")
              ? "Redirecting to connect your account \u23f3"
              : hasVariant($state, "connectingWith", "twitter")
              ? "Redirecting to connect your account \u23f3"
              : "Choose a Source Category:"}
          </div>
        </div>
        {(
          hasVariant($state, "categoryOverviewForType", "spotify")
            ? true
            : hasVariant($state, "categoryOverviewForType", "twitter")
            ? true
            : hasVariant($state, "categoryOverviewForType", "youtube")
            ? true
            : hasVariant($state, "categoryTypeOverview", "free")
            ? true
            : hasVariant($state, "categoryTypeOverview", "complete")
            ? true
            : hasVariant($state, "categoryTypeOverview", "pro")
            ? true
            : hasVariant($state, "connectingWith", "spotify")
            ? false
            : hasVariant($state, "connectingWith", "twitter")
            ? false
            : true
        ) ? (
          <div
            data-plasmic-name={"sourceCategoryButtonStack"}
            data-plasmic-override={overrides.sourceCategoryButtonStack}
            className={classNames(
              projectcss.all,
              sty.sourceCategoryButtonStack,
              {
                [sty.sourceCategoryButtonStackcategoryOverviewForType_spotify]:
                  hasVariant($state, "categoryOverviewForType", "spotify"),
                [sty.sourceCategoryButtonStackcategoryOverviewForType_twitter]:
                  hasVariant($state, "categoryOverviewForType", "twitter"),
                [sty.sourceCategoryButtonStackcategoryOverviewForType_youtube]:
                  hasVariant($state, "categoryOverviewForType", "youtube"),
                [sty.sourceCategoryButtonStackcategoryTypeOverview_complete]:
                  hasVariant($state, "categoryTypeOverview", "complete"),
                [sty.sourceCategoryButtonStackcategoryTypeOverview_free]:
                  hasVariant($state, "categoryTypeOverview", "free"),
                [sty.sourceCategoryButtonStackcategoryTypeOverview_pro]:
                  hasVariant($state, "categoryTypeOverview", "pro"),
                [sty.sourceCategoryButtonStackconnectingWith_spotify]:
                  hasVariant($state, "connectingWith", "spotify"),
                [sty.sourceCategoryButtonStackconnectingWith_twitter]:
                  hasVariant($state, "connectingWith", "twitter")
              }
            )}
          >
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? true
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? true
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? true
                : hasVariant($state, "connectingWith", "twitter")
                ? true
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"websites"}
                data-plasmic-override={overrides.websites}
                category={"websites"}
                className={classNames("__wab_instance", sty.websites, {
                  [sty.websitescategoryOverviewForType_spotify]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "spotify"
                  ),
                  [sty.websitescategoryOverviewForType_twitter]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "twitter"
                  ),
                  [sty.websitescategoryOverviewForType_youtube]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "youtube"
                  ),
                  [sty.websitescategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.websitescategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.websitescategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.websitesconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.websitesconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? false
                : hasVariant($state, "connectingWith", "twitter")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"youtube"}
                data-plasmic-override={overrides.youtube}
                category={
                  hasVariant($state, "categoryTypeOverview", "free")
                    ? "youtube"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "youtube"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "youtube"
                    : undefined
                }
                className={classNames("__wab_instance", sty.youtube, {
                  [sty.youtubecategoryOverviewForType_spotify]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "spotify"
                  ),
                  [sty.youtubecategoryOverviewForType_twitter]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "twitter"
                  ),
                  [sty.youtubecategoryOverviewForType_youtube]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "youtube"
                  ),
                  [sty.youtubecategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.youtubecategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.youtubecategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.youtubeconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.youtubeconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? false
                : hasVariant($state, "connectingWith", "twitter")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"youtubeChannels"}
                data-plasmic-override={overrides.youtubeChannels}
                category={
                  hasVariant($state, "categoryOverviewForType", "youtube")
                    ? "youtubeChannels"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "youtube"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "youtube"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "youtube"
                    : undefined
                }
                className={classNames("__wab_instance", sty.youtubeChannels, {
                  [sty.youtubeChannelscategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.youtubeChannelscategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.youtubeChannelscategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.youtubeChannelscategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.youtubeChannelscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.youtubeChannelscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.youtubeChannelsconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.youtubeChannelsconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? false
                : hasVariant($state, "connectingWith", "twitter")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"youtubePlaylists"}
                data-plasmic-override={overrides.youtubePlaylists}
                category={
                  hasVariant($state, "categoryOverviewForType", "youtube")
                    ? "youtubePlaylists"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "youtube"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "youtube"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "youtube"
                    : undefined
                }
                className={classNames("__wab_instance", sty.youtubePlaylists, {
                  [sty.youtubePlaylistscategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.youtubePlaylistscategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.youtubePlaylistscategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.youtubePlaylistscategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.youtubePlaylistscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.youtubePlaylistscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.youtubePlaylistsconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.youtubePlaylistsconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? false
                : hasVariant($state, "connectingWith", "twitter")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"twitter"}
                data-plasmic-override={overrides.twitter}
                category={
                  hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : undefined
                }
                className={classNames("__wab_instance", sty.twitter, {
                  [sty.twittercategoryOverviewForType_spotify]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "spotify"
                  ),
                  [sty.twittercategoryOverviewForType_twitter]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "twitter"
                  ),
                  [sty.twittercategoryOverviewForType_youtube]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "youtube"
                  ),
                  [sty.twittercategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.twittercategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.twittercategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.twitterconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.twitterconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"twitterTimelines"}
                data-plasmic-override={overrides.twitterTimelines}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "twitterUserTimelines"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterUserTimelines"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterUserTimelines"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterUserTimelines"
                    : undefined
                }
                className={classNames("__wab_instance", sty.twitterTimelines, {
                  [sty.twitterTimelinescategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.twitterTimelinescategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.twitterTimelinescategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.twitterTimelinescategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.twitterTimelinescategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.twitterTimelinescategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.twitterTimelinesconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.twitterTimelinesconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"twitterBookmarks"}
                data-plasmic-override={overrides.twitterBookmarks}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "twitterBookmarks"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterBookmarks"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterBookmarks"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterBookmarks"
                    : undefined
                }
                className={classNames("__wab_instance", sty.twitterBookmarks, {
                  [sty.twitterBookmarkscategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.twitterBookmarkscategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.twitterBookmarkscategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.twitterBookmarkscategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.twitterBookmarkscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.twitterBookmarkscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.twitterBookmarksconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.twitterBookmarksconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"twitterHomeFeed"}
                data-plasmic-override={overrides.twitterHomeFeed}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "twitterHomeFeed"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterHomeFeed"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterHomeFeed"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterHomeFeed"
                    : undefined
                }
                className={classNames("__wab_instance", sty.twitterHomeFeed, {
                  [sty.twitterHomeFeedcategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.twitterHomeFeedcategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.twitterHomeFeedcategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.twitterHomeFeedcategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.twitterHomeFeedcategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.twitterHomeFeedcategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.twitterHomeFeedconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.twitterHomeFeedconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"twitterLikes"}
                data-plasmic-override={overrides.twitterLikes}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "twitterLikes"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterLikes"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterLikes"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterLikes"
                    : undefined
                }
                className={classNames("__wab_instance", sty.twitterLikes, {
                  [sty.twitterLikescategoryOverviewForType_spotify]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "spotify"
                  ),
                  [sty.twitterLikescategoryOverviewForType_twitter]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "twitter"
                  ),
                  [sty.twitterLikescategoryOverviewForType_youtube]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "youtube"
                  ),
                  [sty.twitterLikescategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.twitterLikescategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.twitterLikescategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.twitterLikesconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.twitterLikesconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"twitterMentions"}
                data-plasmic-override={overrides.twitterMentions}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "twitterMentions"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterMentions"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterMentions"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterMentions"
                    : undefined
                }
                className={classNames("__wab_instance", sty.twitterMentions, {
                  [sty.twitterMentionscategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.twitterMentionscategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.twitterMentionscategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.twitterMentionscategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.twitterMentionscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.twitterMentionscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.twitterMentionsconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.twitterMentionsconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"twitterLists"}
                data-plasmic-override={overrides.twitterLists}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "twitterLists"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterLists"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterLists"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterLists"
                    : undefined
                }
                className={classNames("__wab_instance", sty.twitterLists, {
                  [sty.twitterListscategoryOverviewForType_spotify]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "spotify"
                  ),
                  [sty.twitterListscategoryOverviewForType_twitter]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "twitter"
                  ),
                  [sty.twitterListscategoryOverviewForType_youtube]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "youtube"
                  ),
                  [sty.twitterListscategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.twitterListscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.twitterListscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.twitterListsconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.twitterListsconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"twitterSearches"}
                data-plasmic-override={overrides.twitterSearches}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "twitterLists"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterSearches"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterLists"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterLists"
                    : undefined
                }
                className={classNames("__wab_instance", sty.twitterSearches, {
                  [sty.twitterSearchescategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.twitterSearchescategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.twitterSearchescategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.twitterSearchescategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.twitterSearchescategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.twitterSearchescategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.twitterSearchesconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.twitterSearchesconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "twitter")
                ? true
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"spotifyMusicians"}
                data-plasmic-override={overrides.spotifyMusicians}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "spotifyMusicians"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterLists"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterLists"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterLists"
                    : undefined
                }
                className={classNames("__wab_instance", sty.spotifyMusicians, {
                  [sty.spotifyMusicianscategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.spotifyMusicianscategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.spotifyMusicianscategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.spotifyMusicianscategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.spotifyMusicianscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.spotifyMusicianscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.spotifyMusiciansconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.spotifyMusiciansconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "twitter")
                ? true
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"spotifyPodcasts"}
                data-plasmic-override={overrides.spotifyPodcasts}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "spotifyPodcasts"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterLists"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterLists"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterLists"
                    : undefined
                }
                className={classNames("__wab_instance", sty.spotifyPodcasts, {
                  [sty.spotifyPodcastscategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.spotifyPodcastscategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.spotifyPodcastscategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.spotifyPodcastscategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.spotifyPodcastscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.spotifyPodcastscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.spotifyPodcastsconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.spotifyPodcastsconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "twitter")
                ? true
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"spotifyPlaylists"}
                data-plasmic-override={overrides.spotifyPlaylists}
                category={
                  hasVariant($state, "categoryOverviewForType", "spotify")
                    ? "spotifyPlaylists"
                    : hasVariant($state, "categoryOverviewForType", "twitter")
                    ? "twitterLists"
                    : hasVariant($state, "categoryTypeOverview", "free")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "twitter"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "twitter"
                    : hasVariant($state, "connectingWith", "spotify")
                    ? "twitterLists"
                    : hasVariant($state, "connectingWith", "twitter")
                    ? "twitterLists"
                    : undefined
                }
                className={classNames("__wab_instance", sty.spotifyPlaylists, {
                  [sty.spotifyPlaylistscategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.spotifyPlaylistscategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.spotifyPlaylistscategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.spotifyPlaylistscategoryTypeOverview_complete]:
                    hasVariant($state, "categoryTypeOverview", "complete"),
                  [sty.spotifyPlaylistscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.spotifyPlaylistscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.spotifyPlaylistsconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.spotifyPlaylistsconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? true
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? true
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "categoryTypeOverview", "free")
                ? false
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? true
                : hasVariant($state, "connectingWith", "twitter")
                ? true
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"podcasts"}
                data-plasmic-override={overrides.podcasts}
                category={"podcasts"}
                className={classNames("__wab_instance", sty.podcasts, {
                  [sty.podcastscategoryOverviewForType_spotify]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "spotify"
                  ),
                  [sty.podcastscategoryOverviewForType_twitter]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "twitter"
                  ),
                  [sty.podcastscategoryOverviewForType_youtube]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "youtube"
                  ),
                  [sty.podcastscategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.podcastscategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.podcastscategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.podcastsconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.podcastsconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? true
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? true
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? true
                : hasVariant($state, "connectingWith", "twitter")
                ? true
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"savedForLater"}
                data-plasmic-override={overrides.savedForLater}
                category={"savedForLater"}
                className={classNames("__wab_instance", sty.savedForLater, {
                  [sty.savedForLatercategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.savedForLatercategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.savedForLatercategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.savedForLatercategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.savedForLatercategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.savedForLatercategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.savedForLaterconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.savedForLaterconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              />
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? false
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? false
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? false
                : true
            ) ? (
              <SourceCategoryButton
                data-plasmic-name={"spotify"}
                data-plasmic-override={overrides.spotify}
                category={
                  hasVariant($state, "categoryTypeOverview", "free")
                    ? "spotify"
                    : hasVariant($state, "categoryTypeOverview", "complete")
                    ? "spotify"
                    : hasVariant($state, "categoryTypeOverview", "pro")
                    ? "spotify"
                    : undefined
                }
                className={classNames("__wab_instance", sty.spotify, {
                  [sty.spotifycategoryOverviewForType_spotify]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "spotify"
                  ),
                  [sty.spotifycategoryOverviewForType_twitter]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "twitter"
                  ),
                  [sty.spotifycategoryOverviewForType_youtube]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "youtube"
                  ),
                  [sty.spotifycategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.spotifycategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.spotifycategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  )
                })}
              />
            ) : null}
          </div>
        ) : null}
        {(
          hasVariant($state, "categoryOverviewForType", "spotify")
            ? false
            : hasVariant($state, "categoryOverviewForType", "twitter")
            ? false
            : hasVariant($state, "categoryOverviewForType", "youtube")
            ? false
            : hasVariant($state, "categoryTypeOverview", "free")
            ? false
            : hasVariant($state, "categoryTypeOverview", "complete")
            ? false
            : hasVariant($state, "categoryTypeOverview", "pro")
            ? false
            : hasVariant($state, "connectingWith", "spotify")
            ? false
            : hasVariant($state, "connectingWith", "twitter")
            ? false
            : true
        ) ? (
          <p.Stack
            as={"div"}
            data-plasmic-name={"sourceCategoryOptions"}
            data-plasmic-override={overrides.sourceCategoryOptions}
            hasGap={true}
            className={classNames(projectcss.all, sty.sourceCategoryOptions, {
              [sty.sourceCategoryOptionsbaseVariant__default]: hasVariant(
                $state,
                "baseVariant",
                "_default"
              ),
              [sty.sourceCategoryOptionsbaseVariant_expanded]: hasVariant(
                $state,
                "baseVariant",
                "expanded"
              ),
              [sty.sourceCategoryOptionsbaseVariant_noSources]: hasVariant(
                $state,
                "baseVariant",
                "noSources"
              ),
              [sty.sourceCategoryOptionsbaseVariant_searchResults]: hasVariant(
                $state,
                "baseVariant",
                "searchResults"
              ),
              [sty.sourceCategoryOptionsbaseVariant_searchTermInput]:
                hasVariant($state, "baseVariant", "searchTermInput"),
              [sty.sourceCategoryOptionscategoryOverviewForType_spotify]:
                hasVariant($state, "categoryOverviewForType", "spotify"),
              [sty.sourceCategoryOptionscategoryOverviewForType_twitter]:
                hasVariant($state, "categoryOverviewForType", "twitter"),
              [sty.sourceCategoryOptionscategoryOverviewForType_youtube]:
                hasVariant($state, "categoryOverviewForType", "youtube"),
              [sty.sourceCategoryOptionscategoryTypeOverview_complete]:
                hasVariant($state, "categoryTypeOverview", "complete"),
              [sty.sourceCategoryOptionscategoryTypeOverview_free]: hasVariant(
                $state,
                "categoryTypeOverview",
                "free"
              ),
              [sty.sourceCategoryOptionscategoryTypeOverview_pro]: hasVariant(
                $state,
                "categoryTypeOverview",
                "pro"
              ),
              [sty.sourceCategoryOptionsconnectingWith_spotify]: hasVariant(
                $state,
                "connectingWith",
                "spotify"
              ),
              [sty.sourceCategoryOptionsconnectingWith_twitter]: hasVariant(
                $state,
                "connectingWith",
                "twitter"
              ),
              [sty.sourceCategoryOptionsfooter_hidden]: hasVariant(
                $state,
                "footer",
                "hidden"
              ),
              [sty.sourceCategoryOptionsfooter_twitterConnect]: hasVariant(
                $state,
                "footer",
                "twitterConnect"
              )
            })}
          >
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? true
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? true
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? true
                : hasVariant($state, "categoryTypeOverview", "free")
                ? true
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? true
                : hasVariant($state, "connectingWith", "twitter")
                ? true
                : true
            ) ? (
              <p.Stack
                as={"div"}
                data-plasmic-name={"sourceCategorySelection"}
                data-plasmic-override={overrides.sourceCategorySelection}
                hasGap={true}
                className={classNames(
                  projectcss.all,
                  sty.sourceCategorySelection,
                  {
                    [sty.sourceCategorySelectionbaseVariant_expanded]:
                      hasVariant($state, "baseVariant", "expanded"),
                    [sty.sourceCategorySelectioncategoryOverviewForType_spotify]:
                      hasVariant($state, "categoryOverviewForType", "spotify"),
                    [sty.sourceCategorySelectioncategoryOverviewForType_twitter]:
                      hasVariant($state, "categoryOverviewForType", "twitter"),
                    [sty.sourceCategorySelectioncategoryOverviewForType_youtube]:
                      hasVariant($state, "categoryOverviewForType", "youtube"),
                    [sty.sourceCategorySelectioncategoryTypeOverview_complete]:
                      hasVariant($state, "categoryTypeOverview", "complete"),
                    [sty.sourceCategorySelectioncategoryTypeOverview_free]:
                      hasVariant($state, "categoryTypeOverview", "free"),
                    [sty.sourceCategorySelectioncategoryTypeOverview_pro]:
                      hasVariant($state, "categoryTypeOverview", "pro"),
                    [sty.sourceCategorySelectionconnectingWith_spotify]:
                      hasVariant($state, "connectingWith", "spotify"),
                    [sty.sourceCategorySelectionconnectingWith_twitter]:
                      hasVariant($state, "connectingWith", "twitter")
                  }
                )}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__c1KcU
                  )}
                >
                  {"Source Category:"}
                </div>
                {false ? (
                  <div
                    data-plasmic-name={"plus"}
                    data-plasmic-override={overrides.plus}
                    className={classNames(projectcss.all, sty.plus)}
                  >
                    <div
                      data-plasmic-name={"rectangle3"}
                      data-plasmic-override={overrides.rectangle3}
                      className={classNames(projectcss.all, sty.rectangle3)}
                    />

                    <div
                      data-plasmic-name={"rectangle4"}
                      data-plasmic-override={overrides.rectangle4}
                      className={classNames(projectcss.all, sty.rectangle4)}
                    />
                  </div>
                ) : null}
                {false ? (
                  <EllipseIcon
                    className={classNames(projectcss.all, sty.svg__tVRkB)}
                    role={"img"}
                  />
                ) : null}
                <SourceCategoryButton
                  data-plasmic-name={"currentSourceCategory"}
                  data-plasmic-override={overrides.currentSourceCategory}
                  category={
                    hasVariant($state, "baseVariant", "_default")
                      ? "twitter"
                      : undefined
                  }
                  className={classNames(
                    "__wab_instance",
                    sty.currentSourceCategory,
                    {
                      [sty.currentSourceCategorybaseVariant__default]:
                        hasVariant($state, "baseVariant", "_default"),
                      [sty.currentSourceCategorybaseVariant_urlSearch]:
                        hasVariant($state, "baseVariant", "urlSearch")
                    }
                  )}
                />
              </p.Stack>
            ) : null}
            {(
              hasVariant($state, "categoryOverviewForType", "spotify")
                ? true
                : hasVariant($state, "categoryOverviewForType", "twitter")
                ? true
                : hasVariant($state, "categoryOverviewForType", "youtube")
                ? true
                : hasVariant($state, "categoryTypeOverview", "free")
                ? true
                : hasVariant($state, "categoryTypeOverview", "complete")
                ? false
                : hasVariant($state, "categoryTypeOverview", "pro")
                ? false
                : hasVariant($state, "connectingWith", "spotify")
                ? true
                : hasVariant($state, "connectingWith", "twitter")
                ? true
                : true
            ) ? (
              <p.Stack
                as={"div"}
                data-plasmic-name={"sortingModeBox"}
                data-plasmic-override={overrides.sortingModeBox}
                hasGap={true}
                className={classNames(projectcss.all, sty.sortingModeBox, {
                  [sty.sortingModeBoxbaseVariant__default]: hasVariant(
                    $state,
                    "baseVariant",
                    "_default"
                  ),
                  [sty.sortingModeBoxcategoryOverviewForType_spotify]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.sortingModeBoxcategoryOverviewForType_twitter]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.sortingModeBoxcategoryOverviewForType_youtube]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.sortingModeBoxcategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.sortingModeBoxcategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.sortingModeBoxcategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.sortingModeBoxconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.sortingModeBoxconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                })}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__cUYdF
                  )}
                >
                  {"Sort by:"}
                </div>
                <div
                  data-plasmic-name={"dropdown"}
                  data-plasmic-override={overrides.dropdown}
                  className={classNames(projectcss.all, sty.dropdown, {
                    [sty.dropdownfooter_twitterConnect]: hasVariant(
                      $state,
                      "footer",
                      "twitterConnect"
                    )
                  })}
                >
                  <div
                    data-plasmic-name={"sortingMode"}
                    data-plasmic-override={overrides.sortingMode}
                    className={classNames(projectcss.all, sty.sortingMode, {
                      [sty.sortingModefooter_twitterConnect]: hasVariant(
                        $state,
                        "footer",
                        "twitterConnect"
                      )
                    })}
                  >
                    <div
                      data-plasmic-name={"sortingMode2"}
                      data-plasmic-override={overrides.sortingMode2}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.sortingMode2,
                        {
                          [sty.sortingMode2baseVariant_expanded]: hasVariant(
                            $state,
                            "baseVariant",
                            "expanded"
                          ),
                          [sty.sortingMode2footer_twitterConnect]: hasVariant(
                            $state,
                            "footer",
                            "twitterConnect"
                          )
                        }
                      )}
                    >
                      {"Newest"}
                    </div>
                  </div>
                  <ArrowsIcon
                    className={classNames(projectcss.all, sty.svg__zwMbg)}
                    role={"img"}
                  />
                </div>
                {(() => {
                  try {
                    return $props.vis;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return true;
                    }
                    throw e;
                  }
                })() ? (
                  <Dropdown
                    data-plasmic-name={"sortingModeDropdown"}
                    data-plasmic-override={overrides.sortingModeDropdown}
                    className={classNames(
                      "__wab_instance",
                      sty.sortingModeDropdown,
                      {
                        [sty.sortingModeDropdownbaseVariant__default]:
                          hasVariant($state, "baseVariant", "_default"),
                        [sty.sortingModeDropdownbaseVariant_expanded]:
                          hasVariant($state, "baseVariant", "expanded"),
                        [sty.sortingModeDropdownbaseVariant_noSources]:
                          hasVariant($state, "baseVariant", "noSources"),
                        [sty.sortingModeDropdownbaseVariant_searchTermInput]:
                          hasVariant($state, "baseVariant", "searchTermInput"),
                        [sty.sortingModeDropdownfooter_twitterConnect]:
                          hasVariant($state, "footer", "twitterConnect")
                      }
                    )}
                  />
                ) : null}
              </p.Stack>
            ) : null}
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox___8KOcp, {
                [sty.freeBoxbaseVariant_playlistInput___8KOcpy6WVb]: hasVariant(
                  $state,
                  "baseVariant",
                  "playlistInput"
                ),
                [sty.freeBoxbaseVariant_searchResults___8KOcpERWq]: hasVariant(
                  $state,
                  "baseVariant",
                  "searchResults"
                ),
                [sty.freeBoxbaseVariant_searchTermInput___8KOcplGeLg]:
                  hasVariant($state, "baseVariant", "searchTermInput"),
                [sty.freeBoxbaseVariant_urlSearch___8KOcpQ8Mi]: hasVariant(
                  $state,
                  "baseVariant",
                  "urlSearch"
                ),
                [sty.freeBoxcategoryOverviewForType_spotify___8KOcpO7Fwt]:
                  hasVariant($state, "categoryOverviewForType", "spotify"),
                [sty.freeBoxcategoryOverviewForType_twitter___8KOcpYtWIf]:
                  hasVariant($state, "categoryOverviewForType", "twitter"),
                [sty.freeBoxcategoryOverviewForType_youtube___8KOcpkVGoG]:
                  hasVariant($state, "categoryOverviewForType", "youtube"),
                [sty.freeBoxcategoryTypeOverview_complete___8KOcpWqYA]:
                  hasVariant($state, "categoryTypeOverview", "complete"),
                [sty.freeBoxcategoryTypeOverview_free___8KOcpArOg]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "free"
                ),
                [sty.freeBoxcategoryTypeOverview_pro___8KOcpatOnj]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "pro"
                ),
                [sty.freeBoxconnectingWith_spotify___8KOcpxHcTg]: hasVariant(
                  $state,
                  "connectingWith",
                  "spotify"
                ),
                [sty.freeBoxconnectingWith_twitter___8KOcps4RmW]: hasVariant(
                  $state,
                  "connectingWith",
                  "twitter"
                )
              })}
            >
              <div
                data-plasmic-name={"optionsMenu"}
                data-plasmic-override={overrides.optionsMenu}
                className={classNames(projectcss.all, sty.optionsMenu)}
              >
                <MenuIcon4Icon
                  className={classNames(projectcss.all, sty.svg__yOx4A, {
                    [sty.svgcategoryOverviewForType_spotify__yOx4Ao7Fwt]:
                      hasVariant($state, "categoryOverviewForType", "spotify"),
                    [sty.svgcategoryOverviewForType_twitter__yOx4AYtWIf]:
                      hasVariant($state, "categoryOverviewForType", "twitter"),
                    [sty.svgcategoryOverviewForType_youtube__yOx4AkVGoG]:
                      hasVariant($state, "categoryOverviewForType", "youtube"),
                    [sty.svgcategoryTypeOverview_complete__yOx4AWqYA]:
                      hasVariant($state, "categoryTypeOverview", "complete"),
                    [sty.svgcategoryTypeOverview_free__yOx4AarOg]: hasVariant(
                      $state,
                      "categoryTypeOverview",
                      "free"
                    ),
                    [sty.svgcategoryTypeOverview_pro__yOx4AatOnj]: hasVariant(
                      $state,
                      "categoryTypeOverview",
                      "pro"
                    ),
                    [sty.svgconnectingWith_spotify__yOx4AxHcTg]: hasVariant(
                      $state,
                      "connectingWith",
                      "spotify"
                    ),
                    [sty.svgconnectingWith_twitter__yOx4As4RmW]: hasVariant(
                      $state,
                      "connectingWith",
                      "twitter"
                    )
                  })}
                  role={"img"}
                />
              </div>
              <SmallOverlayMenu
                data-plasmic-name={"overlayMenuBtn"}
                data-plasmic-override={overrides.overlayMenuBtn}
                className={classNames("__wab_instance", sty.overlayMenuBtn, {
                  [sty.overlayMenuBtnfooter_twitterConnect]: hasVariant(
                    $state,
                    "footer",
                    "twitterConnect"
                  )
                })}
                color={"light"}
              />
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__kq6WJ)}>
              <button
                data-plasmic-name={"menuButton"}
                data-plasmic-override={overrides.menuButton}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  sty.menuButton
                )}
                disabled={false}
                ref={ref => {
                  $refs["menuButton"] = ref;
                }}
              >
                <p.PlasmicImg
                  data-plasmic-name={"localHeaderSubmenu"}
                  data-plasmic-override={overrides.localHeaderSubmenu}
                  alt={""}
                  className={classNames(sty.localHeaderSubmenu)}
                  displayHeight={"auto"}
                  displayMaxHeight={"1.56em"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"1.25em"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/715be8d74ced46d5a0b0004b5bd87995.svg",
                    fullWidth: 4.451,
                    fullHeight: 21.999,
                    aspectRatio: 0.227273
                  }}
                />
              </button>
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__bslVd)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__hbfZp)}>
                  <button
                    data-plasmic-name={"closeButton"}
                    data-plasmic-override={overrides.closeButton}
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      sty.closeButton
                    )}
                    onClick={async event => {
                      const $steps = {};
                    }}
                    ref={ref => {
                      $refs["closeButton"] = ref;
                    }}
                  >
                    <ClosesvgIcon
                      data-plasmic-name={"close"}
                      data-plasmic-override={overrides.close}
                      className={classNames(projectcss.all, sty.close)}
                      role={"img"}
                    />
                  </button>
                </div>
                <p.Stack
                  as={"button"}
                  data-plasmic-name={"deleteSectionButton"}
                  data-plasmic-override={overrides.deleteSectionButton}
                  hasGap={true}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.deleteSectionButton,
                    {
                      [sty.deleteSectionButtonfooter_twitterConnect]:
                        hasVariant($state, "footer", "twitterConnect")
                    }
                  )}
                  ref={ref => {
                    $refs["deleteSectionButton"] = ref;
                  }}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__mM0E
                    )}
                  >
                    {"Delete Section"}
                  </div>
                  <IconsDeleteIcon
                    className={classNames(projectcss.all, sty.svg__eWEwD)}
                    role={"img"}
                  />
                </p.Stack>
                <div
                  data-plasmic-name={"group232"}
                  data-plasmic-override={overrides.group232}
                  className={classNames(projectcss.all, sty.group232)}
                >
                  <div
                    data-plasmic-name={"group267"}
                    data-plasmic-override={overrides.group267}
                    className={classNames(projectcss.all, sty.group267)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__mf6Do)}
                      displayHeight={"41px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"108px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/7abb8b92ea8089db6f754e04ec856278.svg",
                        fullWidth: 108,
                        fullHeight: 41,
                        aspectRatio: 2.634146
                      }}
                    />

                    <div
                      data-plasmic-name={"darkMode"}
                      data-plasmic-override={overrides.darkMode}
                      className={classNames(projectcss.all, sty.darkMode)}
                    >
                      <div
                        data-plasmic-name={"darkMode2"}
                        data-plasmic-override={overrides.darkMode2}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.darkMode2
                        )}
                      >
                        {"Dark Mode "}
                      </div>
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"group266"}
                    data-plasmic-override={overrides.group266}
                    className={classNames(projectcss.all, sty.group266)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__voXx9)}
                      displayHeight={"41px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"105px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/f7260f6ff6dc74b62182f7cadfbe7b98.svg",
                        fullWidth: 105,
                        fullHeight: 41,
                        aspectRatio: 2.560976
                      }}
                    />

                    <div
                      data-plasmic-name={"eggshellMode"}
                      data-plasmic-override={overrides.eggshellMode}
                      className={classNames(projectcss.all, sty.eggshellMode)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__uluXg
                        )}
                      >
                        {"Eggshell Mode"}
                      </div>
                    </div>
                  </div>
                </div>
              </p.Stack>
            </div>
          </p.Stack>
        ) : null}
        {(
          hasVariant($state, "baseVariant", "noSources")
            ? false
            : hasVariant($state, "categoryOverviewForType", "spotify")
            ? true
            : hasVariant($state, "categoryOverviewForType", "twitter")
            ? true
            : hasVariant($state, "categoryOverviewForType", "youtube")
            ? true
            : hasVariant($state, "categoryTypeOverview", "free")
            ? false
            : hasVariant($state, "categoryTypeOverview", "complete")
            ? false
            : hasVariant($state, "categoryTypeOverview", "pro")
            ? false
            : hasVariant($state, "connectingWith", "spotify")
            ? true
            : hasVariant($state, "connectingWith", "twitter")
            ? true
            : true
        ) ? (
          <div
            data-plasmic-name={"sectionSettingsContent"}
            data-plasmic-override={overrides.sectionSettingsContent}
            className={classNames(projectcss.all, sty.sectionSettingsContent, {
              [sty.sectionSettingsContentbaseVariant__default]: hasVariant(
                $state,
                "baseVariant",
                "_default"
              ),
              [sty.sectionSettingsContentbaseVariant_noSources]: hasVariant(
                $state,
                "baseVariant",
                "noSources"
              ),
              [sty.sectionSettingsContentbaseVariant_searchResults]: hasVariant(
                $state,
                "baseVariant",
                "searchResults"
              ),
              [sty.sectionSettingsContentbaseVariant_searchTermInput]:
                hasVariant($state, "baseVariant", "searchTermInput"),
              [sty.sectionSettingsContentcategoryOverviewForType_spotify]:
                hasVariant($state, "categoryOverviewForType", "spotify"),
              [sty.sectionSettingsContentcategoryOverviewForType_twitter]:
                hasVariant($state, "categoryOverviewForType", "twitter"),
              [sty.sectionSettingsContentcategoryOverviewForType_youtube]:
                hasVariant($state, "categoryOverviewForType", "youtube"),
              [sty.sectionSettingsContentcategoryTypeOverview_complete]:
                hasVariant($state, "categoryTypeOverview", "complete"),
              [sty.sectionSettingsContentcategoryTypeOverview_free]: hasVariant(
                $state,
                "categoryTypeOverview",
                "free"
              ),
              [sty.sectionSettingsContentcategoryTypeOverview_pro]: hasVariant(
                $state,
                "categoryTypeOverview",
                "pro"
              ),
              [sty.sectionSettingsContentconnectingWith_spotify]: hasVariant(
                $state,
                "connectingWith",
                "spotify"
              ),
              [sty.sectionSettingsContentconnectingWith_twitter]: hasVariant(
                $state,
                "connectingWith",
                "twitter"
              ),
              [sty.sectionSettingsContentfooter_hidden]: hasVariant(
                $state,
                "footer",
                "hidden"
              ),
              [sty.sectionSettingsContentfooter_twitterConnect]: hasVariant(
                $state,
                "footer",
                "twitterConnect"
              )
            })}
          >
            <LineIcon
              className={classNames(projectcss.all, sty.svg__yLj6B, {
                [sty.svgbaseVariant_searchTermInput__yLj6BlGeLg]: hasVariant(
                  $state,
                  "baseVariant",
                  "searchTermInput"
                ),
                [sty.svgcategoryOverviewForType_spotify__yLj6BO7Fwt]:
                  hasVariant($state, "categoryOverviewForType", "spotify"),
                [sty.svgcategoryOverviewForType_twitter__yLj6BYtWIf]:
                  hasVariant($state, "categoryOverviewForType", "twitter"),
                [sty.svgcategoryOverviewForType_youtube__yLj6BkVGoG]:
                  hasVariant($state, "categoryOverviewForType", "youtube"),
                [sty.svgcategoryTypeOverview_complete__yLj6BWqYA]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "complete"
                ),
                [sty.svgcategoryTypeOverview_free__yLj6BArOg]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "free"
                ),
                [sty.svgcategoryTypeOverview_pro__yLj6BatOnj]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "pro"
                ),
                [sty.svgconnectingWith_spotify__yLj6BxHcTg]: hasVariant(
                  $state,
                  "connectingWith",
                  "spotify"
                ),
                [sty.svgconnectingWith_twitter__yLj6Bs4RmW]: hasVariant(
                  $state,
                  "connectingWith",
                  "twitter"
                ),
                [sty.svgfooter_hidden__yLj6B9UZmM]: hasVariant(
                  $state,
                  "footer",
                  "hidden"
                ),
                [sty.svgfooter_twitterConnect__yLj6BhAvbp]: hasVariant(
                  $state,
                  "footer",
                  "twitterConnect"
                )
              })}
              role={"img"}
            />

            <LineIcon
              className={classNames(projectcss.all, sty.svg___1C2Gg, {
                [sty.svgbaseVariant_searchTermInput___1C2GglGeLg]: hasVariant(
                  $state,
                  "baseVariant",
                  "searchTermInput"
                ),
                [sty.svgcategoryOverviewForType_spotify___1C2GgO7Fwt]:
                  hasVariant($state, "categoryOverviewForType", "spotify"),
                [sty.svgcategoryOverviewForType_twitter___1C2GgYtWIf]:
                  hasVariant($state, "categoryOverviewForType", "twitter"),
                [sty.svgcategoryOverviewForType_youtube___1C2GgkVGoG]:
                  hasVariant($state, "categoryOverviewForType", "youtube"),
                [sty.svgcategoryTypeOverview_complete___1C2GgWqYA]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "complete"
                ),
                [sty.svgcategoryTypeOverview_free___1C2GgArOg]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "free"
                ),
                [sty.svgcategoryTypeOverview_pro___1C2GgatOnj]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "pro"
                ),
                [sty.svgconnectingWith_spotify___1C2GgxHcTg]: hasVariant(
                  $state,
                  "connectingWith",
                  "spotify"
                ),
                [sty.svgconnectingWith_twitter___1C2Ggs4RmW]: hasVariant(
                  $state,
                  "connectingWith",
                  "twitter"
                )
              })}
              role={"img"}
            />

            <p.Stack
              as={"div"}
              data-plasmic-name={"contentFrame"}
              data-plasmic-override={overrides.contentFrame}
              hasGap={true}
              className={classNames(projectcss.all, sty.contentFrame, {
                [sty.contentFramebaseVariant__default]: hasVariant(
                  $state,
                  "baseVariant",
                  "_default"
                ),
                [sty.contentFramebaseVariant_expanded]: hasVariant(
                  $state,
                  "baseVariant",
                  "expanded"
                ),
                [sty.contentFramebaseVariant_playlistInput]: hasVariant(
                  $state,
                  "baseVariant",
                  "playlistInput"
                ),
                [sty.contentFramebaseVariant_searchResults]: hasVariant(
                  $state,
                  "baseVariant",
                  "searchResults"
                ),
                [sty.contentFramebaseVariant_searchTermInput]: hasVariant(
                  $state,
                  "baseVariant",
                  "searchTermInput"
                ),
                [sty.contentFramebaseVariant_urlSearch]: hasVariant(
                  $state,
                  "baseVariant",
                  "urlSearch"
                ),
                [sty.contentFramecategoryOverviewForType_spotify]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "spotify"
                ),
                [sty.contentFramecategoryOverviewForType_twitter]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "twitter"
                ),
                [sty.contentFramecategoryOverviewForType_youtube]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "youtube"
                ),
                [sty.contentFramecategoryTypeOverview_complete]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "complete"
                ),
                [sty.contentFramecategoryTypeOverview_free]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "free"
                ),
                [sty.contentFramecategoryTypeOverview_pro]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "pro"
                ),
                [sty.contentFrameconnectingWith_spotify]: hasVariant(
                  $state,
                  "connectingWith",
                  "spotify"
                ),
                [sty.contentFrameconnectingWith_twitter]: hasVariant(
                  $state,
                  "connectingWith",
                  "twitter"
                ),
                [sty.contentFramefooter_hidden]: hasVariant(
                  $state,
                  "footer",
                  "hidden"
                ),
                [sty.contentFramefooter_twitterConnect]: hasVariant(
                  $state,
                  "footer",
                  "twitterConnect"
                )
              })}
            >
              <SectionSettingsSourcePanel
                data-plasmic-name={"sectionSettingsSourcePanel"}
                data-plasmic-override={overrides.sectionSettingsSourcePanel}
                className={classNames(
                  "__wab_instance",
                  sty.sectionSettingsSourcePanel,
                  {
                    [sty.sectionSettingsSourcePanelbaseVariant_expanded]:
                      hasVariant($state, "baseVariant", "expanded"),
                    [sty.sectionSettingsSourcePanelbaseVariant_noSources]:
                      hasVariant($state, "baseVariant", "noSources"),
                    [sty.sectionSettingsSourcePanelbaseVariant_searchResults]:
                      hasVariant($state, "baseVariant", "searchResults"),
                    [sty.sectionSettingsSourcePanelbaseVariant_urlSearch]:
                      hasVariant($state, "baseVariant", "urlSearch"),
                    [sty.sectionSettingsSourcePanelfooter_twitterConnect]:
                      hasVariant($state, "footer", "twitterConnect")
                  }
                )}
              />

              <div
                data-plasmic-name={"sourceList"}
                data-plasmic-override={overrides.sourceList}
                className={classNames(projectcss.all, sty.sourceList, {
                  [sty.sourceListcategoryOverviewForType_spotify]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "spotify"
                  ),
                  [sty.sourceListcategoryOverviewForType_twitter]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "twitter"
                  ),
                  [sty.sourceListcategoryOverviewForType_youtube]: hasVariant(
                    $state,
                    "categoryOverviewForType",
                    "youtube"
                  ),
                  [sty.sourceListcategoryTypeOverview_complete]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.sourceListcategoryTypeOverview_free]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.sourceListcategoryTypeOverview_pro]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.sourceListconnectingWith_spotify]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.sourceListconnectingWith_twitter]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  ),
                  [sty.sourceListfooter_twitterConnect]: hasVariant(
                    $state,
                    "footer",
                    "twitterConnect"
                  )
                })}
              />

              <div
                className={classNames(projectcss.all, sty.freeBox__sxA6S, {
                  [sty.freeBoxbaseVariant__default__sxA6SBswdH]: hasVariant(
                    $state,
                    "baseVariant",
                    "_default"
                  ),
                  [sty.freeBoxbaseVariant_searchTermInput__sxA6SlGeLg]:
                    hasVariant($state, "baseVariant", "searchTermInput")
                })}
              >
                <SearchBar
                  data-plasmic-name={"searchBar"}
                  data-plasmic-override={overrides.searchBar}
                  className={classNames("__wab_instance", sty.searchBar, {
                    [sty.searchBarbaseVariant__default]: hasVariant(
                      $state,
                      "baseVariant",
                      "_default"
                    ),
                    [sty.searchBarbaseVariant_expanded]: hasVariant(
                      $state,
                      "baseVariant",
                      "expanded"
                    ),
                    [sty.searchBarbaseVariant_playlistInput]: hasVariant(
                      $state,
                      "baseVariant",
                      "playlistInput"
                    ),
                    [sty.searchBarbaseVariant_searchResults]: hasVariant(
                      $state,
                      "baseVariant",
                      "searchResults"
                    ),
                    [sty.searchBarbaseVariant_searchTermInput]: hasVariant(
                      $state,
                      "baseVariant",
                      "searchTermInput"
                    ),
                    [sty.searchBarbaseVariant_urlSearch]: hasVariant(
                      $state,
                      "baseVariant",
                      "urlSearch"
                    ),
                    [sty.searchBarfooter_twitterConnect]: hasVariant(
                      $state,
                      "footer",
                      "twitterConnect"
                    )
                  })}
                />

                <Button
                  className={classNames("__wab_instance", sty.button__lLs1K, {
                    [sty.buttonbaseVariant_searchTermInput__lLs1KlGeLg]:
                      hasVariant($state, "baseVariant", "searchTermInput")
                  })}
                  color={"lightBlue"}
                  size={"compact"}
                  submitsForm={true}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__kNVrX
                    )}
                  >
                    {"add Search Term as a Source"}
                  </div>
                </Button>
              </div>
              {(
                hasVariant($state, "baseVariant", "searchTermInput")
                  ? false
                  : hasVariant($state, "categoryOverviewForType", "spotify")
                  ? true
                  : hasVariant($state, "categoryOverviewForType", "twitter")
                  ? true
                  : hasVariant($state, "categoryOverviewForType", "youtube")
                  ? true
                  : hasVariant($state, "categoryTypeOverview", "free")
                  ? true
                  : hasVariant($state, "categoryTypeOverview", "complete")
                  ? true
                  : hasVariant($state, "categoryTypeOverview", "pro")
                  ? true
                  : hasVariant($state, "connectingWith", "spotify")
                  ? true
                  : hasVariant($state, "connectingWith", "twitter")
                  ? true
                  : true
              ) ? (
                <div
                  data-plasmic-name={"resultsPanel"}
                  data-plasmic-override={overrides.resultsPanel}
                  className={classNames(projectcss.all, sty.resultsPanel, {
                    [sty.resultsPanelbaseVariant__default]: hasVariant(
                      $state,
                      "baseVariant",
                      "_default"
                    ),
                    [sty.resultsPanelbaseVariant_expanded]: hasVariant(
                      $state,
                      "baseVariant",
                      "expanded"
                    ),
                    [sty.resultsPanelbaseVariant_playlistInput]: hasVariant(
                      $state,
                      "baseVariant",
                      "playlistInput"
                    ),
                    [sty.resultsPanelbaseVariant_searchResults]: hasVariant(
                      $state,
                      "baseVariant",
                      "searchResults"
                    ),
                    [sty.resultsPanelbaseVariant_searchTermInput]: hasVariant(
                      $state,
                      "baseVariant",
                      "searchTermInput"
                    ),
                    [sty.resultsPanelbaseVariant_urlSearch]: hasVariant(
                      $state,
                      "baseVariant",
                      "urlSearch"
                    ),
                    [sty.resultsPanelcategoryOverviewForType_spotify]:
                      hasVariant($state, "categoryOverviewForType", "spotify"),
                    [sty.resultsPanelcategoryOverviewForType_twitter]:
                      hasVariant($state, "categoryOverviewForType", "twitter"),
                    [sty.resultsPanelcategoryOverviewForType_youtube]:
                      hasVariant($state, "categoryOverviewForType", "youtube"),
                    [sty.resultsPanelcategoryTypeOverview_complete]: hasVariant(
                      $state,
                      "categoryTypeOverview",
                      "complete"
                    ),
                    [sty.resultsPanelcategoryTypeOverview_free]: hasVariant(
                      $state,
                      "categoryTypeOverview",
                      "free"
                    ),
                    [sty.resultsPanelcategoryTypeOverview_pro]: hasVariant(
                      $state,
                      "categoryTypeOverview",
                      "pro"
                    ),
                    [sty.resultsPanelconnectingWith_spotify]: hasVariant(
                      $state,
                      "connectingWith",
                      "spotify"
                    ),
                    [sty.resultsPanelconnectingWith_twitter]: hasVariant(
                      $state,
                      "connectingWith",
                      "twitter"
                    ),
                    [sty.resultsPanelfooter_hidden]: hasVariant(
                      $state,
                      "footer",
                      "hidden"
                    ),
                    [sty.resultsPanelfooter_twitterConnect]: hasVariant(
                      $state,
                      "footer",
                      "twitterConnect"
                    )
                  })}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__emtA3,
                      {
                        [sty.textbaseVariant_expanded__emtA3ECdj]: hasVariant(
                          $state,
                          "baseVariant",
                          "expanded"
                        ),
                        [sty.textbaseVariant_searchResults__emtA3ERWq]:
                          hasVariant($state, "baseVariant", "searchResults")
                      }
                    )}
                  >
                    {"Interests"}
                  </div>
                  <InterestTilePanel
                    data-plasmic-name={"interestTilePanel"}
                    data-plasmic-override={overrides.interestTilePanel}
                    className={classNames(
                      "__wab_instance",
                      sty.interestTilePanel,
                      {
                        [sty.interestTilePanelbaseVariant__default]: hasVariant(
                          $state,
                          "baseVariant",
                          "_default"
                        ),
                        [sty.interestTilePanelbaseVariant_expanded]: hasVariant(
                          $state,
                          "baseVariant",
                          "expanded"
                        ),
                        [sty.interestTilePanelbaseVariant_searchResults]:
                          hasVariant($state, "baseVariant", "searchResults"),
                        [sty.interestTilePanelfooter_twitterConnect]:
                          hasVariant($state, "footer", "twitterConnect")
                      }
                    )}
                    interestStack={null}
                  />

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__iSi,
                      {
                        [sty.textbaseVariant__default__iSiBswdH]: hasVariant(
                          $state,
                          "baseVariant",
                          "_default"
                        ),
                        [sty.textbaseVariant_expanded__iSiECdj]: hasVariant(
                          $state,
                          "baseVariant",
                          "expanded"
                        ),
                        [sty.textbaseVariant_playlistInput__iSiy6WVb]:
                          hasVariant($state, "baseVariant", "playlistInput"),
                        [sty.textbaseVariant_searchResults__iSiERWq]:
                          hasVariant($state, "baseVariant", "searchResults"),
                        [sty.textbaseVariant_searchTermInput__iSilGeLg]:
                          hasVariant($state, "baseVariant", "searchTermInput"),
                        [sty.textbaseVariant_urlSearch__iSiQ8Mi]: hasVariant(
                          $state,
                          "baseVariant",
                          "urlSearch"
                        ),
                        [sty.textfooter_hidden__iSi9UZmM]: hasVariant(
                          $state,
                          "footer",
                          "hidden"
                        ),
                        [sty.textfooter_twitterConnect__iSihAvbp]: hasVariant(
                          $state,
                          "footer",
                          "twitterConnect"
                        )
                      }
                    )}
                  >
                    {"Based on your interests:"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__tPx0G, {
                      [sty.freeBoxbaseVariant__default__tPx0GBswdH]: hasVariant(
                        $state,
                        "baseVariant",
                        "_default"
                      ),
                      [sty.freeBoxbaseVariant_expanded__tPx0GECdj]: hasVariant(
                        $state,
                        "baseVariant",
                        "expanded"
                      ),
                      [sty.freeBoxbaseVariant_playlistInput__tPx0Gy6WVb]:
                        hasVariant($state, "baseVariant", "playlistInput"),
                      [sty.freeBoxbaseVariant_searchResults__tPx0GeRWq]:
                        hasVariant($state, "baseVariant", "searchResults"),
                      [sty.freeBoxbaseVariant_searchTermInput__tPx0GlGeLg]:
                        hasVariant($state, "baseVariant", "searchTermInput"),
                      [sty.freeBoxbaseVariant_urlSearch__tPx0GQ8Mi]: hasVariant(
                        $state,
                        "baseVariant",
                        "urlSearch"
                      ),
                      [sty.freeBoxfooter_twitterConnect__tPx0GhAvbp]:
                        hasVariant($state, "footer", "twitterConnect")
                    })}
                  >
                    <div
                      data-plasmic-name={"suggestionContainer"}
                      data-plasmic-override={overrides.suggestionContainer}
                      className={classNames(
                        projectcss.all,
                        sty.suggestionContainer,
                        {
                          [sty.suggestionContainerbaseVariant__default]:
                            hasVariant($state, "baseVariant", "_default"),
                          [sty.suggestionContainerbaseVariant_playlistInput]:
                            hasVariant($state, "baseVariant", "playlistInput"),
                          [sty.suggestionContainerbaseVariant_searchTermInput]:
                            hasVariant(
                              $state,
                              "baseVariant",
                              "searchTermInput"
                            ),
                          [sty.suggestionContainerbaseVariant_urlSearch]:
                            hasVariant($state, "baseVariant", "urlSearch"),
                          [sty.suggestionContainerfooter_twitterConnect]:
                            hasVariant($state, "footer", "twitterConnect")
                        }
                      )}
                    >
                      <Arrows
                        data-plasmic-name={"arrows"}
                        data-plasmic-override={overrides.arrows}
                        className={classNames("__wab_instance", sty.arrows, {
                          [sty.arrowsbaseVariant_searchResults]: hasVariant(
                            $state,
                            "baseVariant",
                            "searchResults"
                          ),
                          [sty.arrowsfooter_twitterConnect]: hasVariant(
                            $state,
                            "footer",
                            "twitterConnect"
                          )
                        })}
                        small={true}
                      />

                      <div
                        data-plasmic-name={"suggestionStack"}
                        data-plasmic-override={overrides.suggestionStack}
                        className={classNames(
                          projectcss.all,
                          sty.suggestionStack,
                          {
                            [sty.suggestionStackbaseVariant__default]:
                              hasVariant($state, "baseVariant", "_default"),
                            [sty.suggestionStackbaseVariant_expanded]:
                              hasVariant($state, "baseVariant", "expanded"),
                            [sty.suggestionStackbaseVariant_playlistInput]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "playlistInput"
                              ),
                            [sty.suggestionStackbaseVariant_searchResults]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "searchResults"
                              ),
                            [sty.suggestionStackbaseVariant_searchTermInput]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "searchTermInput"
                              ),
                            [sty.suggestionStackbaseVariant_urlSearch]:
                              hasVariant($state, "baseVariant", "urlSearch"),
                            [sty.suggestionStackfooter_twitterConnect]:
                              hasVariant($state, "footer", "twitterConnect")
                          }
                        )}
                      >
                        {p.renderPlasmicSlot({
                          defaultContents: null,
                          value: args.suggestionStack
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {(
                hasVariant($state, "baseVariant", "urlSearch")
                  ? false
                  : hasVariant($state, "baseVariant", "searchTermInput")
                  ? false
                  : hasVariant($state, "baseVariant", "playlistInput")
                  ? false
                  : hasVariant($state, "baseVariant", "expanded")
                  ? true
                  : hasVariant($state, "baseVariant", "searchResults")
                  ? true
                  : hasVariant($state, "footer", "twitterConnect")
                  ? true
                  : true
              ) ? (
                <div
                  data-plasmic-name={"expandButton"}
                  data-plasmic-override={overrides.expandButton}
                  className={classNames(projectcss.all, sty.expandButton, {
                    [sty.expandButtonbaseVariant__default]: hasVariant(
                      $state,
                      "baseVariant",
                      "_default"
                    ),
                    [sty.expandButtonbaseVariant_expanded]: hasVariant(
                      $state,
                      "baseVariant",
                      "expanded"
                    ),
                    [sty.expandButtonbaseVariant_playlistInput]: hasVariant(
                      $state,
                      "baseVariant",
                      "playlistInput"
                    ),
                    [sty.expandButtonbaseVariant_searchResults]: hasVariant(
                      $state,
                      "baseVariant",
                      "searchResults"
                    ),
                    [sty.expandButtonbaseVariant_searchTermInput]: hasVariant(
                      $state,
                      "baseVariant",
                      "searchTermInput"
                    ),
                    [sty.expandButtonbaseVariant_urlSearch]: hasVariant(
                      $state,
                      "baseVariant",
                      "urlSearch"
                    ),
                    [sty.expandButtonfooter_twitterConnect]: hasVariant(
                      $state,
                      "footer",
                      "twitterConnect"
                    )
                  })}
                >
                  <button
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      projectcss.__wab_text,
                      sty.button___6KRvH,
                      {
                        [sty.buttonbaseVariant__default___6KRvHBswdH]:
                          hasVariant($state, "baseVariant", "_default"),
                        [sty.buttonbaseVariant_expanded___6KRvHECdj]:
                          hasVariant($state, "baseVariant", "expanded"),
                        [sty.buttonbaseVariant_playlistInput___6KRvHy6WVb]:
                          hasVariant($state, "baseVariant", "playlistInput"),
                        [sty.buttonbaseVariant_searchResults___6KRvHeRWq]:
                          hasVariant($state, "baseVariant", "searchResults"),
                        [sty.buttonbaseVariant_searchTermInput___6KRvHlGeLg]:
                          hasVariant($state, "baseVariant", "searchTermInput"),
                        [sty.buttonbaseVariant_urlSearch___6KRvHQ8Mi]:
                          hasVariant($state, "baseVariant", "urlSearch"),
                        [sty.buttoncategoryOverviewForType_spotify___6KRvHo7Fwt]:
                          hasVariant(
                            $state,
                            "categoryOverviewForType",
                            "spotify"
                          ),
                        [sty.buttoncategoryOverviewForType_twitter___6KRvHYtWIf]:
                          hasVariant(
                            $state,
                            "categoryOverviewForType",
                            "twitter"
                          ),
                        [sty.buttoncategoryOverviewForType_youtube___6KRvHkVGoG]:
                          hasVariant(
                            $state,
                            "categoryOverviewForType",
                            "youtube"
                          ),
                        [sty.buttoncategoryTypeOverview_complete___6KRvHWqYA]:
                          hasVariant(
                            $state,
                            "categoryTypeOverview",
                            "complete"
                          ),
                        [sty.buttoncategoryTypeOverview_free___6KRvHarOg]:
                          hasVariant($state, "categoryTypeOverview", "free"),
                        [sty.buttoncategoryTypeOverview_pro___6KRvHatOnj]:
                          hasVariant($state, "categoryTypeOverview", "pro"),
                        [sty.buttonconnectingWith_spotify___6KRvHxHcTg]:
                          hasVariant($state, "connectingWith", "spotify"),
                        [sty.buttonconnectingWith_twitter___6KRvHs4RmW]:
                          hasVariant($state, "connectingWith", "twitter"),
                        [sty.buttonfooter_twitterConnect___6KRvHhAvbp]:
                          hasVariant($state, "footer", "twitterConnect")
                      }
                    )}
                  >
                    {"Show more suggestions"}
                  </button>
                </div>
              ) : null}
            </p.Stack>
          </div>
        ) : null}
        {(
          hasVariant($state, "baseVariant", "noSources")
            ? false
            : hasVariant($state, "categoryOverviewForType", "spotify")
            ? false
            : hasVariant($state, "categoryOverviewForType", "twitter")
            ? false
            : hasVariant($state, "categoryOverviewForType", "youtube")
            ? false
            : hasVariant($state, "categoryTypeOverview", "free")
            ? false
            : hasVariant($state, "categoryTypeOverview", "complete")
            ? false
            : hasVariant($state, "categoryTypeOverview", "pro")
            ? false
            : hasVariant($state, "connectingWith", "spotify")
            ? false
            : hasVariant($state, "connectingWith", "twitter")
            ? false
            : true
        ) ? (
          <div
            className={classNames(projectcss.all, sty.freeBox__kosLt, {
              [sty.freeBoxbaseVariant_expanded__kosLtECdj]: hasVariant(
                $state,
                "baseVariant",
                "expanded"
              ),
              [sty.freeBoxbaseVariant_noSources__kosLTaeYH]: hasVariant(
                $state,
                "baseVariant",
                "noSources"
              ),
              [sty.freeBoxbaseVariant_searchResults__kosLteRWq]: hasVariant(
                $state,
                "baseVariant",
                "searchResults"
              ),
              [sty.freeBoxcategoryOverviewForType_spotify__kosLto7Fwt]:
                hasVariant($state, "categoryOverviewForType", "spotify"),
              [sty.freeBoxcategoryOverviewForType_twitter__kosLtYtWIf]:
                hasVariant($state, "categoryOverviewForType", "twitter"),
              [sty.freeBoxcategoryOverviewForType_youtube__kosLTkVGoG]:
                hasVariant($state, "categoryOverviewForType", "youtube"),
              [sty.freeBoxcategoryTypeOverview_complete__kosLtWqYA]: hasVariant(
                $state,
                "categoryTypeOverview",
                "complete"
              ),
              [sty.freeBoxcategoryTypeOverview_free__kosLtarOg]: hasVariant(
                $state,
                "categoryTypeOverview",
                "free"
              ),
              [sty.freeBoxcategoryTypeOverview_pro__kosLTatOnj]: hasVariant(
                $state,
                "categoryTypeOverview",
                "pro"
              ),
              [sty.freeBoxconnectingWith_spotify__kosLTxHcTg]: hasVariant(
                $state,
                "connectingWith",
                "spotify"
              ),
              [sty.freeBoxconnectingWith_twitter__kosLTs4RmW]: hasVariant(
                $state,
                "connectingWith",
                "twitter"
              ),
              [sty.freeBoxfooter_hidden__kosLt9UZmM]: hasVariant(
                $state,
                "footer",
                "hidden"
              ),
              [sty.freeBoxfooter_twitterConnect__kosLThAvbp]: hasVariant(
                $state,
                "footer",
                "twitterConnect"
              )
            })}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"footerButton"}
              data-plasmic-override={overrides.footerButton}
              hasGap={true}
              className={classNames(projectcss.all, sty.footerButton, {
                [sty.footerButtonbaseVariant__default]: hasVariant(
                  $state,
                  "baseVariant",
                  "_default"
                ),
                [sty.footerButtonbaseVariant_searchResults]: hasVariant(
                  $state,
                  "baseVariant",
                  "searchResults"
                ),
                [sty.footerButtoncategoryOverviewForType_spotify]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "spotify"
                ),
                [sty.footerButtoncategoryOverviewForType_twitter]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "twitter"
                ),
                [sty.footerButtoncategoryOverviewForType_youtube]: hasVariant(
                  $state,
                  "categoryOverviewForType",
                  "youtube"
                ),
                [sty.footerButtoncategoryTypeOverview_complete]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "complete"
                ),
                [sty.footerButtoncategoryTypeOverview_free]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "free"
                ),
                [sty.footerButtoncategoryTypeOverview_pro]: hasVariant(
                  $state,
                  "categoryTypeOverview",
                  "pro"
                ),
                [sty.footerButtonconnectingWith_spotify]: hasVariant(
                  $state,
                  "connectingWith",
                  "spotify"
                ),
                [sty.footerButtonconnectingWith_twitter]: hasVariant(
                  $state,
                  "connectingWith",
                  "twitter"
                ),
                [sty.footerButtonfooter_hidden]: hasVariant(
                  $state,
                  "footer",
                  "hidden"
                ),
                [sty.footerButtonfooter_twitterConnect]: hasVariant(
                  $state,
                  "footer",
                  "twitterConnect"
                )
              })}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mkps0,
                  {
                    [sty.textcategoryOverviewForType_spotify__mkps0O7Fwt]:
                      hasVariant($state, "categoryOverviewForType", "spotify"),
                    [sty.textcategoryOverviewForType_twitter__mkps0YtWIf]:
                      hasVariant($state, "categoryOverviewForType", "twitter"),
                    [sty.textcategoryOverviewForType_youtube__mkps0KVGoG]:
                      hasVariant($state, "categoryOverviewForType", "youtube"),
                    [sty.textcategoryTypeOverview_complete__mkps0WqYA]:
                      hasVariant($state, "categoryTypeOverview", "complete"),
                    [sty.textcategoryTypeOverview_free__mkps0ArOg]: hasVariant(
                      $state,
                      "categoryTypeOverview",
                      "free"
                    ),
                    [sty.textcategoryTypeOverview_pro__mkps0AtOnj]: hasVariant(
                      $state,
                      "categoryTypeOverview",
                      "pro"
                    ),
                    [sty.textconnectingWith_spotify__mkps0XHcTg]: hasVariant(
                      $state,
                      "connectingWith",
                      "spotify"
                    ),
                    [sty.textconnectingWith_twitter__mkps0S4RmW]: hasVariant(
                      $state,
                      "connectingWith",
                      "twitter"
                    ),
                    [sty.textfooter_hidden__mkps09UZmM]: hasVariant(
                      $state,
                      "footer",
                      "hidden"
                    ),
                    [sty.textfooter_twitterConnect__mkps0HAvbp]: hasVariant(
                      $state,
                      "footer",
                      "twitterConnect"
                    )
                  }
                )}
              >
                {hasVariant($state, "footer", "hidden")
                  ? "Connect Account"
                  : "Connect Account"}
              </div>
              <_27IcontwitterIcon
                className={classNames(projectcss.all, sty.svg__uyMx, {
                  [sty.svgcategoryOverviewForType_spotify__uyMxo7Fwt]:
                    hasVariant($state, "categoryOverviewForType", "spotify"),
                  [sty.svgcategoryOverviewForType_twitter__uyMxYtWIf]:
                    hasVariant($state, "categoryOverviewForType", "twitter"),
                  [sty.svgcategoryOverviewForType_youtube__uyMXkVGoG]:
                    hasVariant($state, "categoryOverviewForType", "youtube"),
                  [sty.svgcategoryTypeOverview_complete__uyMxWqYA]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "complete"
                  ),
                  [sty.svgcategoryTypeOverview_free__uyMxarOg]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "free"
                  ),
                  [sty.svgcategoryTypeOverview_pro__uyMXatOnj]: hasVariant(
                    $state,
                    "categoryTypeOverview",
                    "pro"
                  ),
                  [sty.svgconnectingWith_spotify__uyMXxHcTg]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.svgconnectingWith_twitter__uyMXs4RmW]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  ),
                  [sty.svgfooter_twitterConnect__uyMXhAvbp]: hasVariant(
                    $state,
                    "footer",
                    "twitterConnect"
                  )
                })}
                role={"img"}
              />
            </p.Stack>
          </div>
        ) : null}
        {(
          hasVariant($state, "categoryTypeOverview", "free")
            ? false
            : hasVariant($state, "categoryTypeOverview", "pro")
            ? false
            : hasVariant($state, "connectingWith", "spotify")
            ? true
            : hasVariant($state, "connectingWith", "twitter")
            ? true
            : true
        ) ? (
          <div
            data-plasmic-name={"redirectingDelete"}
            data-plasmic-override={overrides.redirectingDelete}
            className={classNames(projectcss.all, sty.redirectingDelete, {
              [sty.redirectingDeletecategoryTypeOverview_free]: hasVariant(
                $state,
                "categoryTypeOverview",
                "free"
              ),
              [sty.redirectingDeletecategoryTypeOverview_pro]: hasVariant(
                $state,
                "categoryTypeOverview",
                "pro"
              ),
              [sty.redirectingDeleteconnectingWith_spotify]: hasVariant(
                $state,
                "connectingWith",
                "spotify"
              ),
              [sty.redirectingDeleteconnectingWith_twitter]: hasVariant(
                $state,
                "connectingWith",
                "twitter"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__dePq,
                {
                  [sty.textconnectingWith_spotify__dePQxHcTg]: hasVariant(
                    $state,
                    "connectingWith",
                    "spotify"
                  ),
                  [sty.textconnectingWith_twitter__dePQs4RmW]: hasVariant(
                    $state,
                    "connectingWith",
                    "twitter"
                  )
                }
              )}
            >
              {"Redirecting to connect you with Twitter"}
            </div>
          </div>
        ) : null}
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "sectionSettings",
    "sourceCategorySelectionBackButton",
    "leftArrow",
    "sourceCategoryButtonStack",
    "websites",
    "youtube",
    "youtubeChannels",
    "youtubePlaylists",
    "twitter",
    "twitterTimelines",
    "twitterBookmarks",
    "twitterHomeFeed",
    "twitterLikes",
    "twitterMentions",
    "twitterLists",
    "twitterSearches",
    "spotifyMusicians",
    "spotifyPodcasts",
    "spotifyPlaylists",
    "podcasts",
    "savedForLater",
    "spotify",
    "sourceCategoryOptions",
    "sourceCategorySelection",
    "plus",
    "rectangle3",
    "rectangle4",
    "currentSourceCategory",
    "sortingModeBox",
    "dropdown",
    "sortingMode",
    "sortingMode2",
    "sortingModeDropdown",
    "optionsMenu",
    "overlayMenuBtn",
    "menuButton",
    "localHeaderSubmenu",
    "closeButton",
    "close",
    "deleteSectionButton",
    "group232",
    "group267",
    "darkMode",
    "darkMode2",
    "group266",
    "eggshellMode",
    "sectionSettingsContent",
    "contentFrame",
    "sectionSettingsSourcePanel",
    "sourceList",
    "searchBar",
    "resultsPanel",
    "interestTilePanel",
    "suggestionContainer",
    "arrows",
    "suggestionStack",
    "expandButton",
    "footerButton",
    "redirectingDelete"
  ],
  sectionSettings: [
    "sectionSettings",
    "sourceCategorySelectionBackButton",
    "leftArrow",
    "sourceCategoryButtonStack",
    "websites",
    "youtube",
    "youtubeChannels",
    "youtubePlaylists",
    "twitter",
    "twitterTimelines",
    "twitterBookmarks",
    "twitterHomeFeed",
    "twitterLikes",
    "twitterMentions",
    "twitterLists",
    "twitterSearches",
    "spotifyMusicians",
    "spotifyPodcasts",
    "spotifyPlaylists",
    "podcasts",
    "savedForLater",
    "spotify",
    "sourceCategoryOptions",
    "sourceCategorySelection",
    "plus",
    "rectangle3",
    "rectangle4",
    "currentSourceCategory",
    "sortingModeBox",
    "dropdown",
    "sortingMode",
    "sortingMode2",
    "sortingModeDropdown",
    "optionsMenu",
    "overlayMenuBtn",
    "menuButton",
    "localHeaderSubmenu",
    "closeButton",
    "close",
    "deleteSectionButton",
    "group232",
    "group267",
    "darkMode",
    "darkMode2",
    "group266",
    "eggshellMode",
    "sectionSettingsContent",
    "contentFrame",
    "sectionSettingsSourcePanel",
    "sourceList",
    "searchBar",
    "resultsPanel",
    "interestTilePanel",
    "suggestionContainer",
    "arrows",
    "suggestionStack",
    "expandButton",
    "footerButton",
    "redirectingDelete"
  ],
  sourceCategorySelectionBackButton: [
    "sourceCategorySelectionBackButton",
    "leftArrow"
  ],
  leftArrow: ["leftArrow"],
  sourceCategoryButtonStack: [
    "sourceCategoryButtonStack",
    "websites",
    "youtube",
    "youtubeChannels",
    "youtubePlaylists",
    "twitter",
    "twitterTimelines",
    "twitterBookmarks",
    "twitterHomeFeed",
    "twitterLikes",
    "twitterMentions",
    "twitterLists",
    "twitterSearches",
    "spotifyMusicians",
    "spotifyPodcasts",
    "spotifyPlaylists",
    "podcasts",
    "savedForLater",
    "spotify"
  ],
  websites: ["websites"],
  youtube: ["youtube"],
  youtubeChannels: ["youtubeChannels"],
  youtubePlaylists: ["youtubePlaylists"],
  twitter: ["twitter"],
  twitterTimelines: ["twitterTimelines"],
  twitterBookmarks: ["twitterBookmarks"],
  twitterHomeFeed: ["twitterHomeFeed"],
  twitterLikes: ["twitterLikes"],
  twitterMentions: ["twitterMentions"],
  twitterLists: ["twitterLists"],
  twitterSearches: ["twitterSearches"],
  spotifyMusicians: ["spotifyMusicians"],
  spotifyPodcasts: ["spotifyPodcasts"],
  spotifyPlaylists: ["spotifyPlaylists"],
  podcasts: ["podcasts"],
  savedForLater: ["savedForLater"],
  spotify: ["spotify"],
  sourceCategoryOptions: [
    "sourceCategoryOptions",
    "sourceCategorySelection",
    "plus",
    "rectangle3",
    "rectangle4",
    "currentSourceCategory",
    "sortingModeBox",
    "dropdown",
    "sortingMode",
    "sortingMode2",
    "sortingModeDropdown",
    "optionsMenu",
    "overlayMenuBtn",
    "menuButton",
    "localHeaderSubmenu",
    "closeButton",
    "close",
    "deleteSectionButton",
    "group232",
    "group267",
    "darkMode",
    "darkMode2",
    "group266",
    "eggshellMode"
  ],
  sourceCategorySelection: [
    "sourceCategorySelection",
    "plus",
    "rectangle3",
    "rectangle4",
    "currentSourceCategory"
  ],
  plus: ["plus", "rectangle3", "rectangle4"],
  rectangle3: ["rectangle3"],
  rectangle4: ["rectangle4"],
  currentSourceCategory: ["currentSourceCategory"],
  sortingModeBox: [
    "sortingModeBox",
    "dropdown",
    "sortingMode",
    "sortingMode2",
    "sortingModeDropdown"
  ],
  dropdown: ["dropdown", "sortingMode", "sortingMode2"],
  sortingMode: ["sortingMode", "sortingMode2"],
  sortingMode2: ["sortingMode2"],
  sortingModeDropdown: ["sortingModeDropdown"],
  optionsMenu: ["optionsMenu"],
  overlayMenuBtn: ["overlayMenuBtn"],
  menuButton: ["menuButton", "localHeaderSubmenu"],
  localHeaderSubmenu: ["localHeaderSubmenu"],
  closeButton: ["closeButton", "close"],
  close: ["close"],
  deleteSectionButton: ["deleteSectionButton"],
  group232: [
    "group232",
    "group267",
    "darkMode",
    "darkMode2",
    "group266",
    "eggshellMode"
  ],
  group267: ["group267", "darkMode", "darkMode2"],
  darkMode: ["darkMode", "darkMode2"],
  darkMode2: ["darkMode2"],
  group266: ["group266", "eggshellMode"],
  eggshellMode: ["eggshellMode"],
  sectionSettingsContent: [
    "sectionSettingsContent",
    "contentFrame",
    "sectionSettingsSourcePanel",
    "sourceList",
    "searchBar",
    "resultsPanel",
    "interestTilePanel",
    "suggestionContainer",
    "arrows",
    "suggestionStack",
    "expandButton"
  ],
  contentFrame: [
    "contentFrame",
    "sectionSettingsSourcePanel",
    "sourceList",
    "searchBar",
    "resultsPanel",
    "interestTilePanel",
    "suggestionContainer",
    "arrows",
    "suggestionStack",
    "expandButton"
  ],
  sectionSettingsSourcePanel: ["sectionSettingsSourcePanel"],
  sourceList: ["sourceList"],
  searchBar: ["searchBar"],
  resultsPanel: [
    "resultsPanel",
    "interestTilePanel",
    "suggestionContainer",
    "arrows",
    "suggestionStack"
  ],
  interestTilePanel: ["interestTilePanel"],
  suggestionContainer: ["suggestionContainer", "arrows", "suggestionStack"],
  arrows: ["arrows"],
  suggestionStack: ["suggestionStack"],
  expandButton: ["expandButton"],
  footerButton: ["footerButton"],
  redirectingDelete: ["redirectingDelete"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  sectionSettings: "div";
  sourceCategorySelectionBackButton: "button";
  leftArrow: "svg";
  sourceCategoryButtonStack: "div";
  websites: typeof SourceCategoryButton;
  youtube: typeof SourceCategoryButton;
  youtubeChannels: typeof SourceCategoryButton;
  youtubePlaylists: typeof SourceCategoryButton;
  twitter: typeof SourceCategoryButton;
  twitterTimelines: typeof SourceCategoryButton;
  twitterBookmarks: typeof SourceCategoryButton;
  twitterHomeFeed: typeof SourceCategoryButton;
  twitterLikes: typeof SourceCategoryButton;
  twitterMentions: typeof SourceCategoryButton;
  twitterLists: typeof SourceCategoryButton;
  twitterSearches: typeof SourceCategoryButton;
  spotifyMusicians: typeof SourceCategoryButton;
  spotifyPodcasts: typeof SourceCategoryButton;
  spotifyPlaylists: typeof SourceCategoryButton;
  podcasts: typeof SourceCategoryButton;
  savedForLater: typeof SourceCategoryButton;
  spotify: typeof SourceCategoryButton;
  sourceCategoryOptions: "div";
  sourceCategorySelection: "div";
  plus: "div";
  rectangle3: "div";
  rectangle4: "div";
  currentSourceCategory: typeof SourceCategoryButton;
  sortingModeBox: "div";
  dropdown: "div";
  sortingMode: "div";
  sortingMode2: "div";
  sortingModeDropdown: typeof Dropdown;
  optionsMenu: "div";
  overlayMenuBtn: typeof SmallOverlayMenu;
  menuButton: "button";
  localHeaderSubmenu: typeof p.PlasmicImg;
  closeButton: "button";
  close: "svg";
  deleteSectionButton: "button";
  group232: "div";
  group267: "div";
  darkMode: "div";
  darkMode2: "div";
  group266: "div";
  eggshellMode: "div";
  sectionSettingsContent: "div";
  contentFrame: "div";
  sectionSettingsSourcePanel: typeof SectionSettingsSourcePanel;
  sourceList: "div";
  searchBar: typeof SearchBar;
  resultsPanel: "div";
  interestTilePanel: typeof InterestTilePanel;
  suggestionContainer: "div";
  arrows: typeof Arrows;
  suggestionStack: "div";
  expandButton: "div";
  footerButton: "div";
  redirectingDelete: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSectionSettings__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSectionSettings__VariantsArgs;
    args?: PlasmicSectionSettings__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSectionSettings__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSectionSettings__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionSettings__ArgProps,
          internalVariantPropNames: PlasmicSectionSettings__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionSettings__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSectionSettings";
  } else {
    func.displayName = `PlasmicSectionSettings.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionSettings = Object.assign(
  // Top-level PlasmicSectionSettings renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sectionSettings: makeNodeComponent("sectionSettings"),
    sourceCategorySelectionBackButton: makeNodeComponent(
      "sourceCategorySelectionBackButton"
    ),
    leftArrow: makeNodeComponent("leftArrow"),
    sourceCategoryButtonStack: makeNodeComponent("sourceCategoryButtonStack"),
    websites: makeNodeComponent("websites"),
    youtube: makeNodeComponent("youtube"),
    youtubeChannels: makeNodeComponent("youtubeChannels"),
    youtubePlaylists: makeNodeComponent("youtubePlaylists"),
    twitter: makeNodeComponent("twitter"),
    twitterTimelines: makeNodeComponent("twitterTimelines"),
    twitterBookmarks: makeNodeComponent("twitterBookmarks"),
    twitterHomeFeed: makeNodeComponent("twitterHomeFeed"),
    twitterLikes: makeNodeComponent("twitterLikes"),
    twitterMentions: makeNodeComponent("twitterMentions"),
    twitterLists: makeNodeComponent("twitterLists"),
    twitterSearches: makeNodeComponent("twitterSearches"),
    spotifyMusicians: makeNodeComponent("spotifyMusicians"),
    spotifyPodcasts: makeNodeComponent("spotifyPodcasts"),
    spotifyPlaylists: makeNodeComponent("spotifyPlaylists"),
    podcasts: makeNodeComponent("podcasts"),
    savedForLater: makeNodeComponent("savedForLater"),
    spotify: makeNodeComponent("spotify"),
    sourceCategoryOptions: makeNodeComponent("sourceCategoryOptions"),
    sourceCategorySelection: makeNodeComponent("sourceCategorySelection"),
    plus: makeNodeComponent("plus"),
    rectangle3: makeNodeComponent("rectangle3"),
    rectangle4: makeNodeComponent("rectangle4"),
    currentSourceCategory: makeNodeComponent("currentSourceCategory"),
    sortingModeBox: makeNodeComponent("sortingModeBox"),
    dropdown: makeNodeComponent("dropdown"),
    sortingMode: makeNodeComponent("sortingMode"),
    sortingMode2: makeNodeComponent("sortingMode2"),
    sortingModeDropdown: makeNodeComponent("sortingModeDropdown"),
    optionsMenu: makeNodeComponent("optionsMenu"),
    overlayMenuBtn: makeNodeComponent("overlayMenuBtn"),
    menuButton: makeNodeComponent("menuButton"),
    localHeaderSubmenu: makeNodeComponent("localHeaderSubmenu"),
    closeButton: makeNodeComponent("closeButton"),
    close: makeNodeComponent("close"),
    deleteSectionButton: makeNodeComponent("deleteSectionButton"),
    group232: makeNodeComponent("group232"),
    group267: makeNodeComponent("group267"),
    darkMode: makeNodeComponent("darkMode"),
    darkMode2: makeNodeComponent("darkMode2"),
    group266: makeNodeComponent("group266"),
    eggshellMode: makeNodeComponent("eggshellMode"),
    sectionSettingsContent: makeNodeComponent("sectionSettingsContent"),
    contentFrame: makeNodeComponent("contentFrame"),
    sectionSettingsSourcePanel: makeNodeComponent("sectionSettingsSourcePanel"),
    sourceList: makeNodeComponent("sourceList"),
    searchBar: makeNodeComponent("searchBar"),
    resultsPanel: makeNodeComponent("resultsPanel"),
    interestTilePanel: makeNodeComponent("interestTilePanel"),
    suggestionContainer: makeNodeComponent("suggestionContainer"),
    arrows: makeNodeComponent("arrows"),
    suggestionStack: makeNodeComponent("suggestionStack"),
    expandButton: makeNodeComponent("expandButton"),
    footerButton: makeNodeComponent("footerButton"),
    redirectingDelete: makeNodeComponent("redirectingDelete"),

    // Metadata about props expected for PlasmicSectionSettings
    internalVariantProps: PlasmicSectionSettings__VariantProps,
    internalArgProps: PlasmicSectionSettings__ArgProps
  }
);

export default PlasmicSectionSettings;
/* prettier-ignore-end */
